var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ADD_TO_CART_ERROR, ADD_TO_CART_REQUEST, ADD_TO_CART_SUCCESS, CANCEL_SIGN_EDITING, CANVAS_TYPE_CHANGED, CART_IMAGES, DECAL_EDITOR_SETTINGS_LOAD_ERROR, DECAL_EDITOR_SETTINGS_RECEIVE, DECAL_ICONS_RECEIVE, DELETE_TEMPLATE_SUCCESS, DISCARD_TEMPLATE, LOAD_E_SIGN_EDITOR_TEMPLATE_SUCCESS, LOAD_SIGN_FOR_EDIT_ERROR, LOAD_SIGN_FOR_EDIT_REQUEST, LOAD_SIGN_FOR_EDIT_SUCCESS, LOAD_TEMPLATE_REQUEST, LOAD_TEMPLATE_SUCCESS, LOAD_TEMPLATES_REQUEST, LOAD_TEMPLATES_SUCCESS, LOCK_CANVAS_EDITING, RESET_CANVAS, } from '../../Rutab/RutabConstants';
import { load } from '../../Actions/Rutab/RutabCart.action';
import { get, post, put, remove, uploadFile } from '../../Services/http';
import { catchError } from '../Error.action';
import { CART_RECEIVE, CART_SHOW_INFO } from '../../constants';
import { handleUrlUpdate } from '../../Helpers/UrlService';
export const loadDecalEditorSettings = () => (dispatch, getState) => {
    return get('/api/decal/settings')
        .then((response) => response.json())
        .then((settings) => {
        dispatch(receiveDecalEditorSettings(settings));
        dispatch({
            type: CANVAS_TYPE_CHANGED,
            payload: { canvasType: settings.decalProductsSettings[0] },
        });
    })
        .catch((ex) => dispatch(catchError(ex, (error) => loadDecalEditorSettingsError(error))));
};
export const loadDecalEditorSettingsError = (error) => ({
    type: DECAL_EDITOR_SETTINGS_LOAD_ERROR,
    payload: {
        error,
    },
});
export const receiveDecalEditorSettings = (settings) => ({
    type: DECAL_EDITOR_SETTINGS_RECEIVE,
    payload: {
        settings,
    },
});
export const receive = (cart) => ({
    type: CART_RECEIVE,
    payload: cart,
});
export const addToCart = (requestModel, quantity) => (dispatch, getState) => {
    dispatch({ type: ADD_TO_CART_REQUEST });
    return post(`/api/decal/cart/add?quantity=${quantity}`, requestModel)
        .then((response) => {
        response === null || response === void 0 ? void 0 : response.json();
    })
        .then((result) => {
        dispatch(addToCartSuccess(result));
        dispatch(resetCanvasToDefaults());
        dispatch(load());
        // Dispatch a custom event to trigger the cart animation
        const cartAddedEvent = new CustomEvent('cartItemAdded', {
            detail: { quantity: quantity },
        });
        window.dispatchEvent(cartAddedEvent);
        return result;
    })
        .catch((ex) => {
        ex.response.json().then((result) => {
            dispatch(addToCartError(result));
        });
    });
};
export const updateCartItem = (requestModel, quantity) => (dispatch, getState) => {
    dispatch({ type: ADD_TO_CART_REQUEST });
    return put(`/api/decal/cart/update?quantity=${quantity}`, requestModel)
        .then((response) => {
        response === null || response === void 0 ? void 0 : response.json();
    })
        .then((result) => {
        dispatch(addToCartSuccess(result));
        dispatch(resetCanvasToDefaults(false));
        dispatch(load());
        // Dispatch a custom event to trigger the cart animation
        const cartAddedEvent = new CustomEvent('cartItemAdded', {
            detail: { quantity: quantity },
        });
        window.dispatchEvent(cartAddedEvent);
        return result;
    })
        .catch((ex) => {
        ex.response.json().then((result) => {
            dispatch(addToCartError(result));
        });
    });
};
export const removeCartItem = (rowSystemId, resetCanvas = false) => (dispatch, getState) => {
    return put(`/api/decal/cart/delete/${rowSystemId}?resetCanvas=${resetCanvas}`)
        .then((response) => {
        response === null || response === void 0 ? void 0 : response.json();
    })
        .then((result) => {
        if (resetCanvas) {
            dispatch(resetCanvasToDefaults(true));
            handleUrlUpdate();
        }
        dispatch(load());
        return result;
    })
        .catch((ex) => {
        ex.response.json().then((result) => {
            dispatch(addToCartError(result));
        });
    });
};
export const addToCartSuccess = (result) => ({
    type: ADD_TO_CART_SUCCESS,
    payload: {
        result,
    },
});
export const addToCartError = (error) => ({
    type: ADD_TO_CART_ERROR,
    payload: {
        error,
    },
});
export const resetCanvas = () => ({
    type: RESET_CANVAS,
});
export const resetCanvasToDefaults = (resetEditingSign = true, loadSign = false) => (dispatch, getState) => {
    var _a;
    const state = getState();
    const canvasType = (_a = state.decalEditorAPI.settings) === null || _a === void 0 ? void 0 : _a.decalProductsSettings[0];
    const editingSign = state.decalEditorAPI.signForEdit;
    const productTemplate = state.decalEditorAPI.productTemplate;
    const selectedTemplate = state.decalEditorAPI.selectedTemplate;
    dispatch({
        type: RESET_CANVAS,
        payload: {
            defaultCanvasType: canvasType,
        },
    });
    requestAnimationFrame(() => {
        if (editingSign && resetEditingSign) {
            dispatch({ type: CANCEL_SIGN_EDITING });
            dispatch({
                type: CART_SHOW_INFO,
                payload: {
                    showInfo: false,
                },
            });
        }
        if (productTemplate) {
            dispatch(loadESignEditorTemplateSuccess(null));
        }
        if (selectedTemplate) {
            dispatch({ type: DISCARD_TEMPLATE });
        }
        if (loadSign && editingSign) {
            dispatch(loadSignForEdit(editingSign.rowSystemId));
        }
    });
};
export const loadSignForEdit = (id) => (dispatch, getState) => {
    dispatch({
        type: LOAD_SIGN_FOR_EDIT_REQUEST,
        payload: {
            isLoading: true,
        },
    });
    return get(`/api/decal/cart/get-for-edit/${id}`)
        .then((response) => response.json())
        .then((sign) => {
        if (sign.productTemplateId) {
            dispatch(loadESignTemplate(sign.productTemplateId));
        }
        dispatch(loadSignForEditSuccess(sign));
    })
        .catch((ex) => {
        ex.response.json().then((result) => {
            dispatch(loadSignForEditError(result));
        });
    });
};
export const loadSignForEditSuccess = (sign) => ({
    type: LOAD_SIGN_FOR_EDIT_SUCCESS,
    payload: {
        sign,
    },
});
export const loadSignForEditError = (error) => ({
    type: LOAD_SIGN_FOR_EDIT_ERROR,
    payload: {
        error,
    },
});
export const uploadImage = (file) => __awaiter(void 0, void 0, void 0, function* () {
    const formData = new FormData();
    formData.append('image', file);
    return uploadFile('/api/decal/upload-image', formData)
        .then((response) => {
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
    })
        .then((result) => {
        return result;
    })
        .catch((ex) => {
        ex.response.json().then((result) => {
            console.log(result);
        });
    });
});
export const loadCartImages = () => (dispatch, getState) => {
    return get('/api/decal/cart-images')
        .then((response) => response.json())
        .then((images) => {
        dispatch({
            type: CART_IMAGES,
            payload: {
                images,
            },
        });
    })
        .catch((ex) => {
        ex.response.json().then((result) => {
            console.log(result);
        });
    });
};
export const loadDecalIcons = () => (dispatch, getState) => {
    return get('/api/decal/icons')
        .then((response) => response.json())
        .then((decalIcons) => {
        dispatch(loadDecalIconsSuccess(decalIcons));
    });
};
export const loadDecalIconsSuccess = (decalIcons) => ({
    type: DECAL_ICONS_RECEIVE,
    payload: {
        decalIcons,
    },
});
export const calculatePrice = (priceRequest) => __awaiter(void 0, void 0, void 0, function* () {
    return post(`/api/decal/price`, priceRequest)
        .then((response) => {
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
    })
        .then((result) => {
        return result;
    })
        .catch((ex) => {
        ex.response.json().then((result) => {
            console.log(result);
        });
    });
});
export const saveTemplate = (saveEditorTemplateData) => (dispatch, getState) => {
    return post('/api/decal/templates/create', saveEditorTemplateData)
        .then((response) => {
        response === null || response === void 0 ? void 0 : response.json();
    })
        .then((result) => {
        dispatch(resetCanvasToDefaults(true));
        dispatch(loadTemplates());
        return result;
    })
        .catch((ex) => {
        console.error('Error saving template:', ex);
        throw ex;
    });
};
export const updateTemplate = (id, saveEditorTemplateData) => (dispatch, getState) => {
    return post(`/api/decal/templates/${id}/save`, saveEditorTemplateData)
        .then((response) => {
        response === null || response === void 0 ? void 0 : response.json();
    })
        .then((result) => {
        dispatch(resetCanvasToDefaults(true));
        dispatch(loadTemplates());
        return result;
    })
        .catch((ex) => {
        console.error('Error saving template:', ex);
        throw ex;
    });
};
/** Print shop admin only. Organizations a template can be bound to, matched on name or organization number. */
export const searchTemplateOwnerOrganizations = (searchTerm) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield get(`/api/decal/templates/owners/organizations?searchTerm=${encodeURIComponent(searchTerm !== null && searchTerm !== void 0 ? searchTerm : '')}`);
    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }
    return yield response.json();
});
/** Print shop admin only. The users within an organization a template can be bound to. */
export const loadTemplateOwnerPersons = (organizationId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield get(`/api/decal/templates/owners/organizations/${organizationId}/persons`);
    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }
    return yield response.json();
});
export const loadESignTemplates = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield get('/api/decal/templates/e-sign');
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return yield response.json();
    }
    catch (ex) {
        console.error('Error loading templates:', ex);
        throw ex;
    }
});
export const loadESignTemplate = (id) => (dispatch, getState) => {
    dispatch({
        type: LOAD_SIGN_FOR_EDIT_REQUEST,
        payload: {
            isLoading: true,
        },
    });
    return get(`/api/decal/templates/e-sign/${id}`)
        .then((response) => response.json())
        .then((template) => {
        requestAnimationFrame(() => {
            dispatch(loadESignEditorTemplateSuccess(template));
            dispatch({
                type: LOCK_CANVAS_EDITING,
            });
        });
    })
        .catch((ex) => {
        ex.response.json().then((result) => {
            console.log(result);
        });
    });
};
export const loadESignEditorTemplateSuccess = (template) => ({
    type: LOAD_E_SIGN_EDITOR_TEMPLATE_SUCCESS,
    payload: {
        template,
    },
});
export const loadTemplates = () => (dispatch) => {
    dispatch({
        type: LOAD_TEMPLATES_REQUEST,
        payload: {
            isLoading: true,
        },
    });
    return get(`/api/decal/templates/get-all`)
        .then((response) => response.json())
        .then((templates) => {
        dispatch(loadTemplatesSuccess(templates));
    })
        .catch((ex) => {
        ex.response.json().then((result) => {
            console.log(result);
        });
        dispatch({
            type: LOAD_TEMPLATES_REQUEST,
            payload: {
                isLoading: false,
            },
        });
    });
};
export const loadTemplatesSuccess = (templates) => ({
    type: LOAD_TEMPLATES_SUCCESS,
    payload: {
        templates,
    },
});
export const loadTemplate = (id) => (dispatch, getState) => {
    dispatch({
        type: LOAD_TEMPLATE_REQUEST,
        payload: {
            isLoading: true,
            templateId: id,
        },
    });
    return get(`/api/decal/templates/${id}`)
        .then((response) => response.json())
        .then((template) => {
        dispatch(loadTemplateSuccess(template));
        return template;
    })
        .catch((ex) => {
        return ex.response.json().then((result) => {
            dispatch({
                type: LOAD_TEMPLATE_REQUEST,
                payload: {
                    isLoading: false,
                    templateId: null,
                },
            });
            throw result;
        });
    });
};
export const loadTemplateSuccess = (template) => ({
    type: LOAD_TEMPLATE_SUCCESS,
    payload: {
        template,
    },
});
export const deleteTemplate = (id) => (dispatch) => {
    return remove(`/api/decal/templates/${id}/delete`)
        .then(() => {
        dispatch({
            type: DELETE_TEMPLATE_SUCCESS,
            payload: { templateId: id },
        });
        dispatch({
            type: DISCARD_TEMPLATE,
        });
    })
        .catch((ex) => {
        console.error('Error deleting template:', ex);
        throw ex;
    });
};
